import isIterable from '~/src/lib/isIterable';

export const isHandleBooking = (business) => {
    if (
        business &&
        typeof business.info === 'object' &&
        +business.info.handle_booking === 1 &&
        isIterable(business?.info?.showtime)
    ) {
        //https://trello.com/c/YfxkeRVN/1730-sur-menuchiccom-il-y-a-un-%C3%A9l%C3%A9ment-r%C3%A9servation-dans-le-burger-menu-or-le-service-r%C3%A9servation-nest-pas-actif-dans-le-back-office
        const nb = business?.info?.showtime.filter(
            (o) =>
                o.type === 'venue' &&
                (+o.booking === 1) & (+o.booking_status === 1),
        ).length;

        if (nb > 0) {
            return true;
        }
    }

    return false;
};

export default isHandleBooking;
